(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zura-masthead"]) return;
  try {
    
  (() => {
    if (customElements.get('zura-menu-drawer')) return;

    const DESKTOP_QUERY = '(min-width: 1040px)';
    const OPEN_RATIO = 0.99;

    class ZuraMenuDrawer extends HTMLElement {
      #scroller = null;
      #sheet = null;
      #triggers = [];
      #lastTrigger = null;
      #observer = null;
      #desktop = null;
      #inerted = [];
      #opening = false;
      #isOpen = false;

      connectedCallback() {
        this.#scroller = this.querySelector('.zura-drawer__scroller');
        this.#sheet = this.querySelector('.zura-drawer__sheet');
        if (!this.#scroller || !this.#sheet || !this.id) return;

        this.#triggers = [...document.querySelectorAll(`[aria-controls="${this.id}"]`)];
        for (const trigger of this.#triggers) trigger.addEventListener('click', this.open);

        this.addEventListener('click', this.#onClick);
        document.addEventListener('keydown', this.#onKeydown);

        const visible = 1 / window.innerWidth;
        this.#observer = new IntersectionObserver(
          (entries) => {
            if (!this.matches(':popover-open')) return;
            const { intersectionRatio: ratio } = entries.at(-1);
            if (ratio >= OPEN_RATIO) this.#onOpened();
            else if (ratio < visible && !this.#opening) this.#onClosed();
          },
          { root: this, threshold: [visible, OPEN_RATIO] }
        );
        this.#observer.observe(this.#sheet);

        if (!CSS.supports('animation-timeline: scroll()')) {
          this.#scroller.addEventListener('scroll', this.#syncBackdrop, { passive: true });
        }

        this.#desktop = window.matchMedia(DESKTOP_QUERY);
        this.#desktop.addEventListener('change', this.#onBreakpoint);
      }

      disconnectedCallback() {
        for (const trigger of this.#triggers) trigger.removeEventListener('click', this.open);
        document.removeEventListener('keydown', this.#onKeydown);
        this.#desktop?.removeEventListener('change', this.#onBreakpoint);
        this.#observer?.disconnect();
        this.#restorePage();
      }

      open = async (event) => {
        if (this.matches(':popover-open')) return;
        this.#lastTrigger = event?.currentTarget ?? this.#triggers[0] ?? null;
        this.#opening = true;
        this.showPopover();

        if (!CSS.supports('scroll-initial-target', 'nearest')) {
          this.#scroller.scrollTo({ left: this.#scroller.offsetWidth, behavior: 'instant' });
          await new Promise((resolve) =>
            requestAnimationFrame(() => requestAnimationFrame(resolve))
          );
        }

        this.#scroller.scrollTo({ left: 0, behavior: 'auto' });
      };

      close = () => {
        if (!this.matches(':popover-open')) return;
        this.#opening = false;

        const maxScroll = this.#scroller.scrollWidth - this.#scroller.clientWidth;
        if (this.#scroller.scrollLeft >= maxScroll - 1) {
          this.#onClosed();
          return;
        }

        this.#scroller.scrollTo({ left: this.#scroller.offsetWidth, behavior: 'auto' });
      };

      #onOpened() {
        this.#opening = false;
        if (this.#isOpen) return;
        this.#isOpen = true;
        this.#inertPage();
        this.#setExpanded(true);
        this.#sheet.focus({ preventScroll: true });
      }

      #onClosed() {
        if (!this.matches(':popover-open')) return;
        const focusWasInside = this.contains(document.activeElement);
        this.#isOpen = false;
        this.#opening = false;
        this.#restorePage();
        this.hidePopover();
        this.#setExpanded(false);
        this.style.removeProperty('--drawer-backdrop');
        if (focusWasInside) this.#lastTrigger?.focus({ preventScroll: true });
      }

      #onClick = (event) => {
        const target = event.target;
        const tappedBackdrop = !this.#sheet.contains(target);
        const pressedClose = target.closest('[data-drawer-close]');
        const followedLink = target.closest('a[href]');
        if (tappedBackdrop || pressedClose || followedLink) this.close();
      };

      #onKeydown = (event) => {
        if (event.key === 'Escape' && this.matches(':popover-open')) {
          event.preventDefault();
          this.close();
        }
      };

      #onBreakpoint = (event) => {
        if (event.matches && this.matches(':popover-open')) this.#onClosed();
      };

      #syncBackdrop = () => {
        const width = this.#sheet.offsetWidth || 1;
        const ratio = Math.min(1, Math.max(0, 1 - this.#scroller.scrollLeft / width));
        this.style.setProperty('--drawer-backdrop', ratio);
      };

      #setExpanded(expanded) {
        for (const trigger of this.#triggers) {
          trigger.setAttribute('aria-expanded', String(expanded));
        }
      }

      #inertPage() {
        let node = this;
        while (node.parentElement && node !== document.body) {
          for (const sibling of node.parentElement.children) {
            if (sibling !== node && !sibling.inert) {
              sibling.inert = true;
              this.#inerted.push(sibling);
            }
          }
          node = node.parentElement;
        }
      }

      #restorePage() {
        for (const element of this.#inerted) element.inert = false;
        this.#inerted = [];
      }
    }

    customElements.define('zura-menu-drawer', ZuraMenuDrawer);
  })();

  } catch(e) { console.error(e); }
})();
})();
